import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { config, getAssetUrl } from '../../../utils/config';
import onBackToShopClick from '../../../utils/onBackToShopClick';
import { pushTrackingEvent } from '../../../utils/tracking';
import Button from '../../atoms/Button';
import SubHeadline from '../../atoms/SubHeadline';
import './style.scss';

const EmptyBasket = () => {
  useEffect(() => {
    pushTrackingEvent({
      event: 'content_view',
      content_name: `${window.location.pathname}/empty-basket`,
      search: window.location.search || null,
      app_version: 'v3',
      appId: config.appId,
      page_type: 'checkout:error_basket_empty'
    });
  }, []);

  return (
    <div className="empty-basket-container">
      <img src={getAssetUrl('basket/empty.svg')} alt="" />
      <SubHeadline>
        <FormattedMessage id="basket.empty" />
      </SubHeadline>
      <Button onClick={onBackToShopClick}>
        <FormattedMessage id="auth.backToShopping" />
      </Button>
    </div>
  );
};

export default EmptyBasket;
